<template>
  <v-container class="component_main">
    <v-row>
      <v-col class="pb-0" cols="12" sm="6" md="6">
        <h2 class="authorizer-title">{{title}}</h2>
        <small>(totais por operadora)</small>
      </v-col>
      <v-col class="d-flex justify-end pb-0" cols="12" sm="6" md="6">
        <v-btn color="primary" text @click="downloadList" :disabled="!newList.length">
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col class="" cols="12" sm="12" md="12">
        <v-data-table
          :headers="headers"
          :items="newList"
          hide-default-footer
          min="-1"
          max="15"
          dense
        >
          <template v-slot:item="props" >
            <tr  @click="filterSolicitacoes(props.item)">
              <td class="text-center font-list pa-2">{{ operadoras[props.item.operadora_id]}}</td>
              <td class="text-center font-list pa-2">{{ props.item.total}}</td>
              <template v-for="(categoria, ind) in categoriasArray">
                <td class="text-center font-list pa-2" v-bind:key="ind+categoria">
                  <v-row class="card-porcent ma-0">
                    <v-col cols="6" class="pa-0">{{ props.item[categoria] }}</v-col>
                    <v-col cols="6" :style="'background:'+colors[ind]" class="porcentagem"><p class="text-porcent">{{(props.item[categoria]/props.item.total*100).toFixed(2)}}%</p></v-col>
                  </v-row>
                </td>
              </template>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
export default {
  data() {
    return {
      newList: [],
      colors: ["#32b88b", "#b2b842", "#fc9d0a", "#fc5f17", "#d0021b", "#4a4a4a", "#979797"],
      colunasDictionary:{}
    };
  },
  props: {
    categorias: Array,
    date: String,
    filterList: Function,
    headers: Array,
    list: Array,
    periodo: String,
    title: String,
  },
  watch:{
    list() {
      this.formatList()
    }
  },
  computed: {
    ...mapState({
      operadoras: (state) => state.permissions.operadoras
    }),
    categoriasArray() {
      let listaCategorias = this.categorias.map(el=>el.parametro).filter(el=> el!='total')
      return listaCategorias
    }
  },
  mounted() {
    this.formatList()
  },
  methods: {
    ...mapActions('autorizador', [
      "setFilter"
    ]),
    formatList() {
      if(this.tipo == 'solicitacao') {
        this.newList = this.list.map(item => {
          let total = item.total
          item.operadora = this.operadoras[item.operadora_id]
          item.porcentAutorizada = total > 0 ? (item.autorizadas / total * 100).toFixed() : (0).toFixed()  
          item.porcentAutorizadaParcialmente = total>0 ? (item.autorizadas_parcialmente / total * 100).toFixed() : (0).toFixed()    
          item.porcentEmAnalise = total>0 ? (item.em_analise / total * 100).toFixed() : (0).toFixed()    
          item.porcentAguardandoDados = total>0 ? (item.aguardando_dados_prestador / total * 100).toFixed() : (0).toFixed()    
          item.porcentNegada = total>0 ? (item.negadas / total * 100).toFixed() : (0).toFixed()    
          item.porcentCancelada = total>0 ? (item.canceladas / total * 100).toFixed() : (0).toFixed()    
          item.porcentSemResposta = total>0 ? (item.sem_resposta / total * 100).toFixed() : (0).toFixed()   
          return item
        })
        this.colunasDictionary = {
          operadora:"Operadora",
          total: "Total",
          autorizadas: "Autorizadas",
          porcentAutorizada: "Autorizadas(%)",
          autorizadas_parcialmente: "Autorizadas parcialmente",
          porcentAutorizadaParcialmente: "Autorizadas parcialmente (%)",
          em_analise: "Em análise",
          porcentEmAnalise: "Em analise (%)",
          aguardando_dados_prestador: "Aguardando dados do prestador",
          porcentAguardandoDados: "Aguardando dados do prestador (%)",
          negadas: "Negadas",
          porcentNegada: "Negadas (%)",
          canceladas: "Canceladas",
          porcentCancelada: "Canceladas (%)",
          sem_resposta: "Sem resposta",
          porcentSemResposta:"Sem resposta (%)"
        }
      } else {
        this.newList = this.list.map(item => {
          let total = item.total
          item.operadora = this.operadoras[item.operadora_id]
          item.envio_anexos_porc = total > 0 ? (item.envio_anexos / total * 100).toFixed() : (0).toFixed()  
          item.procedimentos_porc = total > 0 ? (item.procedimentos / total * 100).toFixed() : (0).toFixed()    
          item.status_autorizacao_porc = total>0 ? (item.status_autorizacao / total * 100).toFixed() : (0).toFixed()    
          item.elegibilidade_porc = total>0 ? (item.elegibilidade / total * 100).toFixed() : (0).toFixed()    
          item.cancelamento_guia_porc = total > 0 ? (item.cancelamento_guia / total * 100).toFixed() : (0).toFixed()    
          item.comunicacao_beneficiario_porc = total>0 ? (item.comunicacao_beneficiario / total * 100).toFixed() : (0).toFixed()  
          return item
        })
        this.colunasDictionary = {
          operadora:"Operadora",
          total: "Total",
          envio_anexos: "Envio de Anexos",
          envio_anexos_porc: "Envio de Anexos(%)",
          procedimentos: "Solicitação de Procedimentos",
          procedimentos_porc: "Solicitação de Procedimentos(%)",
          status_autorizacao: "Solicitação de status de autoriz.",
          status_autorizacao_porc: "Solicitação de status de autoriz.(%)",
          elegibilidade: "Verificação de Elegibilidade",
          elegibilidade_porc:"Verificação de Elegibilidade(%)",
          cancelamento_guia: "Cancelamento de Guia",
          cancelamento_guia_porc: "Cancelamento de Guia(%)",
          comunicacao_beneficiario: "Comunicação com Beneficiário",
          comunicacao_beneficiario_porc: "Comunicação com Beneficiário(%)"
        }
      }
    },
    convertToCSV(jsonList){
      
      let headerKeys = Object.keys(this.colunasDictionary)
      let header = headerKeys.map(col=>this.colunasDictionary[col])

      let body = jsonList.reduce((str, line) => {
        let newLine = ''
        headerKeys.forEach( key => { 
            if( newLine != '') { newLine += ';'}
            newLine += line[key]
        })
        return str += newLine + '\r\n';
      }, '')
      return "\ufeff" + header.join(';') + '\r\n' + body
    },
    downloadList() {
      let formatoData = this.periodo == 'dia'? 'DD-MM-YYYY': 'MM-YYYY'
      let date = moment(this.date).format(formatoData)
      let fileData = this.convertToCSV(this.newList)
      let fileBlob = new Blob([fileData], { type: 'text/csv; charset=UTF-8;' })
      let downloadUrl = (window.URL || window.webkitURL).createObjectURL(fileBlob)
      let a = document.createElement("a")
      a.href = downloadUrl
      a.download = `totais_por_operadora_${this.periodo}_${date}.csv`
      document.body.appendChild(a)
      a.click();
      URL.revokeObjectURL(downloadUrl)
    },
    filterSolicitacoes(params){
        let periodo = this.periodo
        let operadora_ans_id = params.operadora_id
        let referencedate = this.date
        let data_inicio = periodo == 'dia'? referencedate.split('T')[0] : moment(referencedate).startOf('month').format('YYYY-MM-DD')
        let data_final = periodo == 'dia'? referencedate.split('T')[0] : moment(referencedate).endOf('month').format('YYYY-MM-DD')
        let data = { data_inicio, data_final, periodo, operadora_ans_id }
        this.setFilter(data)
    }
  }
};
</script>

<style>
.porcentagem {
  border-radius: 5px;
  width: 100px;
  padding: 0 0 0 0;
}
.text-porcent {
  font-size: 10px;
  color: white;
  margin: 1px 0 0 !important;
}
.card-porcent {
  width: 80px;
}
.font-list{
  font-family: "system-ui";
}
</style>
